export default "__VITE_ASSET__DAw3jF5W__"